// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3-5gy","head":"ProcedureTableInfo_head__3VcVz"};